import { render, staticRenderFns } from "./VentanasEnturnamientoIndex.vue?vue&type=template&id=791844a8"
import script from "./VentanasEnturnamientoIndex.vue?vue&type=script&lang=js"
export * from "./VentanasEnturnamientoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports